import React from "react";
import {
  Button,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
} from "../../../components/ui";
import { Loader2 } from "lucide-react";
import CustomerFields from "./CustomerFields";
import ProductsSection from "./ProductsSection";

export default function AddLeadModal({
  open,
  onClose,
  customer,
  setCustomer,
  segment,
  setSegment,
  deliveryDate,
  setDeliveryDate,
  today,
  lookupLoading,
  shouldShowError,
  fieldErrors,
  handleBlur,
  loadingProducts,
  products,
  availableProducts,
  updateProduct,
  setProducts,
  addProductRow,
  totalAll,
  err,
  showConfirmDialog,
  setShowConfirmDialog,
  submitting,
  submitLead
}) {
  if (!open) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <div className="title">Add Lead</div>
          <Button variant="outline" onClick={onClose}>Close</Button>
        </div>
        <CustomerFields
          customer={customer}
          setCustomer={setCustomer}
          segment={segment}
          setSegment={setSegment}
          deliveryDate={deliveryDate}
          setDeliveryDate={setDeliveryDate}
          today={today}
          lookupLoading={lookupLoading}
          shouldShowError={shouldShowError}
          fieldErrors={fieldErrors}
          handleBlur={handleBlur}
        />

        <ProductsSection
          loadingProducts={loadingProducts}
          products={products}
          availableProducts={availableProducts}
          updateProduct={updateProduct}
          setProducts={setProducts}
          addProductRow={addProductRow}
          totalAll={totalAll}
          shouldShowError={shouldShowError}
          fieldErrors={fieldErrors}
        />

        {err && <div className="error">{err}</div>}
        <div className="modal-actions">
          <AlertDialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
            <AlertDialogTrigger asChild>
              <Button
                className="bg-green-600 hover:bg-green-700"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Submitting...
                  </>
                ) : (
                  "Submit Lead"
                )}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>Confirm Lead Submission</AlertDialogTitle>
                <AlertDialogDescription>
                  Are you sure you want to submit this lead? This action cannot be undone.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>Cancel</AlertDialogCancel>
                <AlertDialogAction
                  onClick={submitLead}
                  className="bg-green-600 hover:bg-green-700"
                >
                  Submit Lead
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </div>
    </div>
  );
}

